<template>
  <div id="vd-report-page" class="mkt-ops -main-font">
    <div
      style="position: absolute;top: 50%; left: 52%; width: 10%; z-index: 2;"
      v-show="loadData == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div class="md-layout-item md-size-100">
      <label class="title">VOLUME DISCOUNT ANALYSIS</label>
    </div>

    <md-card class="main-content">
      <div class="md-layout md-gutter">
        <div
          class="md-layout-item md-large-size-40 md-medium-size-40 md-small-size-50 md-xsmall-hide"
        >
          <div
            style="width: 412px; margin-left: 10px; margin-top: 20px; display: flex;"
          >
            <multiselect
              v-model="selectedVD"
              label="h_name"
              track-by="vd_id"
              placeholder="Search Volume Discount"
              :open-direction="'bottom'"
              :options="optionsVD"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelVD"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataFilter"
              @close="onCloseVD"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div class="-label">
                    {{ option.h_name }}
                  </div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="
                      clearAll(option.h_name, 'voldiscount')
                    "
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
            <md-button
              class="md-icon-button"
              style="margin-top: 6px; margin-left: 10px;"
              @click="showFilterDialog = true"
            >
              <md-icon>filter_list</md-icon>
            </md-button>
          </div>

          <div
            class="md-layout filter-chips"
            v-if="filterChipsSearch.length > 0"
          >
            <div v-for="(items, idx) in filterChipsSearch" :key="items.keyId">
              <span class="tab-chip -primary" :title="items.name">
                <!-- {{ countString(items) }} -->
                {{ items.name }}
                <span
                  class="tab-chip -delete"
                  @click="deleteFilterSearch(items, idx)"
                >
                  <i class="material-icons">close</i>
                </span>
              </span>
            </div>
          </div>

          <md-card class="box-filter-search">
            <div v-for="(items, idx) in filterChips" :key="items.keyId">
              <div class="tab-chip" :title="items.h_name">
                <div class="-primary">
                  {{ items.h_name }}
                </div>
                <span
                  class="tab-chip -delete"
                  @click="deleteFilter(items, idx)"
                >
                  <i class="material-icons">close</i>
                </span>
              </div>
            </div>
          </md-card>
        </div>

        <div
          class="md-layout-item md-large-size-60 md-medium-size-60 md-small-size-50 md-xsmall-hide"
        >
          <div class="right-filter-search -first">
            <div class="title-search" style="padding-top: 5px;">Start Date</div>
            <div style="width: 25%;">
              <div class="mkt-datepicker">
                <md-datepicker
                  ref="startdate"
                  v-model="vStartDate"
                  md-immediately
                ></md-datepicker>
              </div>
            </div>
            <div style="width: 17%; padding-top: 5px; padding-left: 25px;">
              End Date
            </div>
            <div style="width: 25%;">
              <div class="mkt-datepicker">
                <md-datepicker
                  ref="enddate"
                  class
                  v-model="vEndDate"
                  md-immediately
                ></md-datepicker>
              </div>
            </div>
          </div>
          <div class="right-filter-search">
            <div class="title-search" style="padding-top: 15px;">Cust Code</div>
            <div style="width: 67%;">
              <multiselect
                v-model="selectedCustomer"
                label="title_th"
                track-by="code"
                placeholder="Search Customer"
                :open-direction="'bottom'"
                :options="optionsCustomer"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelCustomer"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">
                      {{ option.code }} - {{ option.title_th }}
                    </div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="
                        clearAll(option.code, 'customer')
                      "
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="right-filter-search" style="margin-top: 5px;">
            <div class="title-search" style="padding-top: 15px;">Salesman Code</div>
            <div style="width: 67%;">
              <multiselect
                v-model="selectedSmCode"
                label="title_th"
                track-by="code"
                placeholder="Search Customer"
                :open-direction="'bottom'"
                :options="optionsSmCode"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelSmCode"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">{{ option.code }}</div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'sm_code')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="right-filter-search">
            <div class="title-search"></div>
            <md-button
              class="md-raised md-primary search-report"
              @click="searchReport()"
              >SEARCH</md-button
            >
            <md-button
              class="md-raised md-primary search-report"
              style="margin-left: 15px;"
              @click="exportReport()"
              >EXPORT</md-button
            >
          </div>
        </div>
      </div>

      <div class="md-layout md-gut ter">
        <div class="md-layout-item chart md-size-100">
          <label class="sub-title">CHART SUMMARY VOLUME DISCOUNT</label>
        </div>

        <div
          class="md-layout-item md-large-size-75 md-medium-size-75 md-small-size-75 md-xsmall-hide"
          style="margin-bottom: 20px;"
        >
          <chart
            class="chart-line"
            :options="optionsChart"
            ref="lineChart"
          ></chart>
        </div>
        <div
          class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-hide"
          style="margin-bottom: 20px; margin-top: 55px;"
        >
          <md-card class="box-detail-chart">
            <div style="font-weight: bold !important; font-size: 14px;">
              Summary
            </div>
            <div class="-total">
              <div class="-title" style="width: 50%;">Total Customer</div>
              <div class="-value" style="width: 50%;">
                {{ chartSummaryCustomer }} &nbsp; &nbsp; Shop
              </div>
            </div>
            <div class="-total">
              <div class="-title" style="width: 40%;">Total Order</div>
              <div class="-value" style="width: 60%;">
                {{ chartSummaryOrder }} &nbsp; Order
              </div>
            </div>
            <div class="-total">
              <div class="-title" style="width: 37%;">Total Amount</div>
              <div class="-value" style="width: 63%;">
                {{ formatNumber(totalAmount, 2) }} &nbsp; &nbsp; Baht
              </div>
            </div>
          </md-card>

          <div
            class="md-layout-item -detail md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-hide"
          >
            <div
              style="display: flex;"
              v-for="(item, rIndex) in optionsChart.series"
              :key="rIndex"
            >
              <div
                class="circle-2017"
                v-bind:style="{ backgroundColor: item.lineStyle.color }"
              ></div>
              <div class="-series">{{ item.name }}</div>
            </div>
            <!--                    <div style="display: flex;">
                        <div class="circle-2017"></div>
                        <div class="-series">Year [2017]</div>
                    </div>
                    <div style="display: flex;">
                        <div class="circle-2018"></div>
                        <div class="-series">Year [2018]</div>
                    </div>
                    <div style="display: flex;">
                        <div class="circle-2019"></div>
                        <div class="-series">Year [2019]</div>
                    </div>-->
          </div>
        </div>
      </div>
    </md-card>

    <md-card class="main-content">
      <div class="md-layout-item list-data md-size-100">
        <label class="sub-title">LIST OF VOLUME DISCOUNT SORTED BY</label>
      </div>

      <div class="md-layout-item table-data md-size-100">
        <div id="table-volume-pricing">
          <div id="divHeadList">
            <!-- <div style="width: 6%;"></div> -->
            <div style="width: 8%;">Cust Code</div>
            <div style="width: 24%">Cust Name</div>
            <div style="width: 7%" class="-text-center">No.</div>
            <div style="width: 12.5%">Volume Discount</div>
            <div style="width: 7%;" class="-text-center">Salesman</div>
            <div style="width: 9%;">PO No.</div>
            <div style="width: 9%;" class="-text-center">PO date</div>
            <div style="width: 8%;" class="-text-right">Amount</div>
            <div style="width: 7.5%;">Inv No.</div>
            <div style="width: 8%;" class="-text-right">Inv Amount</div>
          </div>
          <div id="divBodyList">
            <div
              v-show="tbListReport == null || tbListReport.length == 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center;"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray'"
              v-for="(item, rIndex) in tbListReport"
              :key="rIndex"
            >
              <!-- <div style="width: 6%;">
                            <div class="circle-green -text-center"></div>
                        </div> -->
              <div style="width: 8%;">
                <span>{{ item.cust_code }}</span>
              </div>
              <div style="width: 24%" class="nowrap-title -font-kanit">
                <span :title="item.customer_name_th">{{
                  item.customer_name_th
                }}</span>
              </div>
              <div style="width: 7%" class="-text-center">
                <span>{{ item.no }}</span>
              </div>
              <div style="width: 12.5%" class="nowrap-title -font-kanit">
                <span :title="item.h_name">{{ item.h_name }}</span>
              </div>
              <div style="width: 7%;" class="-text-center">
                <span>{{ item.sm_code }}</span>
              </div>
              <div style="width: 9%;" class="nowrap-title -font-kanit">
                <span :title="item.po_no">{{ item.po_no }}</span>
              </div>
              <div style="width: 9%;" class="-text-center">
                <span>{{ formatDate(item.po_date) }}</span>
              </div>
              <div style="width: 8%;" class="-text-right">
                <span>{{ formatNumber(item.sum_by_set, 2) }}</span>
              </div>
              <div style="width: 7.5%;">
                <span>{{ item.inv_no }}</span>
              </div>
              <div style="width: 8%;" class="-text-right">
                <span>{{ formatNumber(item.inv_total_amount, 2) }}</span>
              </div>
            </div>
          </div>
          <div id="divTableFoot">
            <div style="width: 39%;"></div>
            <div style="width: 12.5%;">
              Count VD : {{ formatNumber(totalVD, 0) }}
            </div>
            <div style="width: 16%;"></div>
            <div style="width: 9%;" class="-text-right">Sum Total :</div>
            <div style="width: 8%;" class="-text-right">
              {{ formatNumber(totalAmount, 2) }}
            </div>
            <div style="width: 7.5%;"></div>
            <div style="width: 8%;" class="-text-right">
              {{ formatNumber(totalNetAmount, 2) }}
            </div>
          </div>
        </div>
      </div>
    </md-card>

    <md-dialog
      :md-active.sync="showFilterDialog"
      class="filter-dialog"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Add Filters</md-dialog-title>
      <div class="layout-dialog">
        <multiselect
          v-model="filterProductGroup"
          label="label"
          track-by="id"
          :placeholder="placeholderPro"
          :options="productGroups"
          :searchable="true"
          :max-height="235"
          :show-no-results="false"
          :select-label="''"
          :deselect-label="''"
          :selected-label="''"
          :hide-selected="true"
          :custom-label="customLabel"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <div>
              <div class="-label">{{ option.id }} - {{ option.label }}</div>
              <div
                class="-delete"
                @mousedown.prevent.stop="clearAll(option.id, 'productgroup')"
              >
                <i class="material-icons">close</i>
              </div>
            </div>
          </template>
        </multiselect>
      </div>

      <md-dialog-actions class="-action">
        <md-button @click="closeFilterDialog" class="md-cancel"
          >cancel</md-button
        >
        <md-button class="md-primary" @click="addCondFilter"
          >add filter</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import Chart from "vue-echarts/components/ECharts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/scatter";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import moment from "moment-timezone";
import promotionService from "@/services/promotion";
import PricingService from "@/services/pricing";
import { constants } from "crypto";

export default {
  name: "volume-discount-report",
  components: {
    Chart
  },
  created() {
    this.getAllProductGroup();
    this.getDataList();
    this.getAllVD();
    this.getAllCustomer();
    this.getAllSmCode();
  },
  data: () => ({
    productGroups: [],
    totalAmount: 0,
    totalNetAmount: 0,
    totalVD: 0,
    showFilterDialog: false,
    filterProductGroup: [],
    placeholderPro: "Filter by Product or Product Group",
    placeholderCust: "Filter by Customer Group",
    filterChipsSearch: [],
    loadData: false,
    dContent: "",
    showSnackbar: false,
    position: "center",
    duration: 4000,
    isInfinity: false,
    filterChips: [],
    selectedVD: [],
    optionsVD: [],
    selectedCustomer: [],
    optionsCustomer: [],
    selectedSmCode: [],
    optionsSmCode: [],
    vStartDate: null,
    vEndDate: null,
    slcProduct: 0,
    track: ["Track"],
    tbListReport: [],
    chartSummaryCustomer: 0,
    chartNetAmountLine: 0,
    chartSummaryOrder: 0,
    // chartSummaryAmount: 0,
    chartSummaryNetAmount: 0,
    colorChartSeries: [
      "#32bbda",
      "#8fb93e",
      "#e61a8b",
      "#c23531",
      "#2f4554",
      "#61a0a8",
      "#d48265",
      "#91c7ae",
      "#ca8622",
      "#749f83",
      "#bda29a",
      "#546570",
      "#c4ccd3"
    ],
    optionsChart: {
      title: {
        text: "CHART SUMMARY VOLUME DISCOUNT",
        x: "center",
        textStyle: {
          color: "#a2a0a0",
          fontWeight: "bold",
          fontFamily: "lato",
          fontSize: 15
        },
        show: false
      },
      tooltip: {
        trigger: "axis"
      },
      legend: {
        //   data: ["Year [2017]", "Year [2018]", "Year [2019]"]
      },
      grid: {
        left: "8%",
        right: "4%",
        bottom: "10%",
        top: "7%",
        containLabel: true
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        name: "SALES VOLUME",
        nameTextStyle: {
          color: "#808080",
          fontWeight: "bold",
          fontFamily: "lato",
          fontSize: 15,
          padding: [25, 0, 0, 0]
        },
        nameLocation: "center",
        type: "category",
        boundaryGap: false,
        data: [
          "",
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yAxis: {
        name: "OUTLET NUMBER",
        nameTextStyle: {
          color: "#808080",
          fontWeight: "bold",
          fontFamily: "lato",
          fontSize: 15,
          padding: [0, 0, 30, 0]
        },
        nameLocation: "center",
        nameRotate: 90,
        type: "value"
        // scale: true
      },
      series: [
        //   {
        //     name: "Year [2017]",
        //     type: "line",
        //     //data: [5, 10, 15, 15, 12, 20, 25, 22, 28, 30, 32, 29],
        //     lineStyle: {
        //       color: "#32bbda"
        //     },
        //     itemStyle: {
        //       color: "#32bbda"
        //     }
        //   },
        //   {
        //     name: "Year [2018]",
        //     type: "line",
        //     //data: [29, 20, 30, 35, 12, 30, 20, 30, 38, 39, 40, 35],
        //     lineStyle: {
        //       color: "#8fb93e"
        //     },
        //     itemStyle: {
        //       color: "#8fb93e"
        //     }
        //   },
        //   {
        //     name: "Year [2019]",
        //     type: "line",
        //     //data: [32, 28, 23, 22, 18, 0, 0, 0, 0, 0, 0, 0],
        //     lineStyle: {
        //       color: "#e61a8b"
        //     },
        //     itemStyle: {
        //       color: "#e61a8b"
        //     }
        //   }
      ]
    }
  }),
  watch: {
    vStartDate() {
      if (
        this.$refs.startdate !== undefined &&
        this.$refs.startdate.$el.children[3] !== undefined
      ) {
        this.$refs.startdate.$el.children[2].addEventListener(
          "click",
          this.clearstartdate,
          false
        );
      }
    },
    vEndDate() {
      if (
        this.$refs.enddate !== undefined &&
        this.$refs.enddate.$el.children[3] !== undefined
      ) {
        this.$refs.enddate.$el.children[2].addEventListener(
          "click",
          this.clearenddate,
          false
        );
      }
    }
  },
  computed: {},
  methods: {
    customLabel({ id, label }) {
      return `${id} - ${label}`;
    },
    addCondFilter() {
      this.showFilterDialog = false;
      this.filterChips = [];
      this.filterChipsSearch = [];
      let obj = {};
      if (this.filterProductGroup.id !== undefined) {
        obj = {
          name: this.filterProductGroup.label,
          id: this.filterProductGroup.id,
          type: "productgroup"
        };
      }

      if (obj.name !== undefined) {
        this.filterChipsSearch.push(obj);
      }
      this.searchVD();
    },
    searchVD() {
      let prodgroup = "";
      if (this.filterProductGroup.id !== undefined) {
        prodgroup = this.filterProductGroup.id;
      }

      let datas = { prodgroup: prodgroup };
      let self = this;
      self.filterChips = [];
      PricingService.filterVD(datas)
        .then(response => {
          if (response) {
            self.filterChips = response;

            response.forEach((value, index) => {
              let key = self.optionsVD.findIndex(
                item => item.h_name === value.h_name
              );
              self.optionsVD.splice(key, 1);
            });
          }
        })
        .catch();
    },
    closeFilterDialog() {
      if (this.filterChipsSearch.length == 0) {
        this.filterProductGroup = [];
      }
      this.showFilterDialog = false;
    },
    // countString(string) {
    //   let num = 44;
    //   let str_val = "";
    //   if (string.id !== undefined) {
    //     str_val = string.id + " - " + string.name;
    //   } else {
    //     str_val = string.name;
    //   }

    //   let str = str_val.length;
    //   if (str > num) {
    //     this.titleChip = true;
    //     return str_val.substr(0, num) + "...";
    //   } else {
    //     this.titleChip = false;
    //     return str_val;
    //   }
    // },
    deleteFilterSearch(items, index) {
      this.filterChipsSearch.splice(index, 1);
      if (items.type == "productgroup") {
        this.filterProductGroup = [];
      }

      if (this.filterChipsSearch.length === 0) {
        this.filterChips = [];
        this.getAllVD();
      } else {
        this.searchVD();
      }
    },
    getAllProductGroup() {
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      let datas = {
        pro_code: "",
        type: "master",
        data_delete: [],
        emp_code: emp_code,
        name: "",
        group: "",
        subgroup: "",
        cg: ""
      };

      PricingService.getAllProductGroup(datas)
        .then(response => {
          if (response.data) {
            response.data.sort((a, b) => (a.id > b.id ? 1 : -1));
            this.productGroups = response.data;
          }
        })
        .catch();
    },
    getAllVD() {
      PricingService.getAllVD()
        .then(response => {
          if (response) {
            response.sort((a, b) => (a.h_name > b.h_name ? 1 : -1));
            this.optionsVD = response;
          }
        })
        .catch();
    },
    getAllCustomer() {
      promotionService
        .getAllCustomer()
        .then(response => {
          if (response) {
            this.optionsCustomer = response;
          }
        })
        .catch();
    },
    getAllSmCode() {
      promotionService
        .getAllSmCode()
        .then(response => {
          if (response) {
            this.optionsSmCode = response;
          }
        })
        .catch();
    },
    customLabelVD({ h_name }) {
      return `${h_name}`;
    },
    customLabelCustomer({ code, title_th }) {
      return `${code} - ${title_th}`;
    },
    customLabelSmCode({ code }) {
      return `${code}`;
    },
    clearAll(id, type) {
      if (type == "voldiscount") {
        this.selectedVD = [];
      } else if (type == "customer") {
        this.selectedCustomer = [];
      } else if (type == "productgroup") {
        this.filterProductGroup = [];
      } else if (type == "sm_code") {
        this.selectedSmCode = [];
      }
    },
    setDataFilter(selectedOption) {
      let obj = {};
      obj = {
        vd_id: selectedOption.vd_id,
        h_name: selectedOption.h_name
      };
      this.filterChips.push(obj);

      let key = this.optionsVD.findIndex(
        item => item.h_name === selectedOption.h_name
      );
      this.optionsVD.splice(key, 1);
    },
    onCloseVD() {
      this.selectedVD = [];
    },
    deleteFilter(items, index) {
      let tmpArr = [];
      for (let i = 0; i < this.filterChips.length; i++) {
        if (i != index) {
          tmpArr.push(this.filterChips[i]);
        }
      }
      this.filterChips = tmpArr;

      this.optionsVD.push(items);
      this.optionsVD.sort((a, b) => (a.h_name > b.h_name ? 1 : -1));

      if (this.filterChips.length === 0) {
        this.filterChipsSearch = [];
        this.filterProductGroup = [];
      }
    },
    clearstartdate() {
      this.vStartDate = null;
    },
    clearenddate() {
      this.vEndDate = null;
    },
    searchReport() {
      this.$nextTick(() => {
        if (
          this.vStartDate === null ||
          this.vStartDate == "" ||
          this.vEndDate === null ||
          this.vEndDate === "" ||
          this.$refs.startdate.$el.children[2] === undefined ||
          this.$refs.enddate.$el.children[2] === undefined
          // this.filterChips.length === 0
        ) {
          // this.dContent = "Please select Volume Discount and Start date - End date";
          this.dContent = "Please select Start date - End date";
          this.showSnackbar = true;
          this.loadData = false;
          return false;
        } else {
          this.getDataList();
        }
      });
    },
    exportReport() {
      let exp_report = this.tbListReport;
      let json_data = [];
      for (let index in exp_report) {
        json_data.push({
          "Cust Code": exp_report[index].cust_code,
          "Cust Name": exp_report[index].customer_name_th,
          "Volume Discount": exp_report[index].h_name,
          "Salesman": exp_report[index].sm_code,
          "PO No": exp_report[index].po_no,
          "PO Date": exp_report[index].po_date,
          Amount: exp_report[index].sum_by_set,
          "Inv No": exp_report[index].inv_no,
          "Inv Amount": exp_report[index].inv_total_amount
        });
      }
      if (json_data.length > 0) {
        this.JSONToCSVConvertor(json_data, "volume_discount_analysis_", true);
      } else {
        alert("data is null");
        return;
      }
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";
      if (ShowLabel) {
        var row = "";
        for (var index in arrData[0]) {
          row += index + ",";
        }

        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }

      for (var i = 0; i < arrData.length; i++) {
        let row = "";
        for (let index in arrData[i]) {
          if (index != "Inv Amount") {
            row += arrData[i][index] + ",";
          } else {
            row += arrData[i][index];
          }
        }

        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      var d = new Date();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var currentDate =
        d.getFullYear() +
        (month < 10 ? "0" : "") +
        month +
        (day < 10 ? "0" : "") +
        day;

      var fileName = ReportTitle + currentDate;
//      var universalBOM = "\uFEFF";
//      var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(universalBOM+CSV);
      var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(CSV);
      var link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(date) {
      // return moment(date).format("YYYY-MM-DD HH:mm:ss");
      // return moment(date).format("YYYY-MM-DD");
      return moment(date).format("DD-MM-YYYY");
    },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        let val = 0;
        return val.toFixed(dicimal);
        // return value;
      } else {
        if (value % 1 == 0) {
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal
          });
        } else {
          if (typeof value === "number") {
            return parseFloat(value).toLocaleString(undefined, {
              minimumFractionDigits: dicimal,
              maximumFractionDigits: dicimal
            });
          } else {
            let parts = value.toString().split(".");
            let num = (parts[0] = parts[0].replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            ));
            let digit = parts[1].slice(0, 3);
            digit = digit.length < 2 ? digit + "0" : digit;
            let rs = num + "." + digit;
            let comma = parseFloat(rs.replace(",", ""));
            // return Math.round(parseFloat(comma) * 100) / 100;
            return parseFloat(
              Math.round(parseFloat(comma) * 100) / 100
            ).toLocaleString(undefined, {
              minimumFractionDigits: dicimal,
              maximumFractionDigits: dicimal
            });
          }
        }
      }
    },
    getDataList() {
      this.loadData = true;
      let arrList = [];
      let sumOfSet = 0;
      let sumInvAmount = 0;
      // let promoCode = "";
      let self = this;
      let currentDate = moment(),
        //currentYear = parseInt(currentDate.format('YYYY')),
        //year_series = [],
        //numberOfYear = 3,
        seriesOfYear = {},
        chartData = {},
        sumCustomer = 0,
        // sumOrder = 0,
        sumAmount = 0,
        sumNetAmount = 0,
        customerAll = [],
        PoAll = [],
        VDAll = [],
        netAmountAll = 0,
        customerPeriod = {};
      /*do {
                year_series[--numberOfYear] = currentYear
                chartData[numberOfYear] = {
                    name: 'Year [' + currentYear + ']',
                    data: ['', 0, 0, 0, 0, 0 ,0 ,0 ,0 ,0 ,0, 0, 0]
                }
                customerPeriod[numberOfYear] = []
                currentYear--
            } while (numberOfYear > 0)*/

      let vd_id = [];
      for (let i = 0; i < this.filterChips.length; i++) {
        vd_id.push(this.filterChips[i].vd_id);
      }

      /* START SEARCH */
      let startDate = "";
      let endDate = "";
      if (this.vStartDate == null && this.vEndDate != null) {
        this.dContent = "Please select start date.";
        this.showSnackbar = true;
        this.loadData = false;
        return false;
      }
      if (this.vStartDate != null && this.vEndDate == null) {
        startDate = moment(this.vStartDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endDate = moment(this.vStartDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else if (this.vStartDate != null && this.vEndDate != null) {
        startDate = moment(this.vStartDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endDate = moment(this.vEndDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      let datas = {
        voldiscount: vd_id.length > 0 ? vd_id : "",
        start_date: startDate,
        end_date: endDate,
        customer: this.selectedCustomer.code ? this.selectedCustomer.code : "",
        sm_code: this.selectedSmCode.code ? this.selectedSmCode.code : "",
        product:
          this.filterProductGroup.id !== undefined
            ? this.filterProductGroup.id
            : ""
      };
      /* END SEARCH */

      this.totalAmount = 0;
      this.totalNetAmount = 0;
      this.totalVD = 0;
      if (
        datas.voldiscount != "" ||
        datas.start_date != "" ||
        datas.end_date != "" ||
        datas.customer != ""
      ) {
        PricingService.ReportList(datas)
          .then(response => {
            for (let i = 0; i < response.length; i++) {
              if (response[i].cust_code !== undefined) {
                if (customerAll.indexOf(response[i].cust_code) === -1) {
                  customerAll.push(response[i].cust_code);
                }
              }
              if (response[i].po_no !== undefined) {
                if (PoAll.indexOf(response[i].po_no) === -1) {
                  PoAll.push(response[i].po_no);
                }
              }
              if (
                response[i].h_name !== undefined &&
                response[i].h_name !== ""
              ) {
                if (VDAll.indexOf(response[i].h_name) === -1) {
                  VDAll.push(response[i].h_name);
                }
              }
              if (
                response[i].inv_no !== undefined &&
                response[i].inv_no !== null &&
                response[i].inv_no !== "" &&
                response[i].inv_no !== 0
              ) {
                netAmountAll++;
                if (response[i].inv_total_amount !== undefined) {
                  sumNetAmount += response[i].inv_total_amount
                    ? parseFloat(response[i].inv_total_amount)
                    : 0;
                }
              }

              // sumOrder++;
              if (response[i].po_date !== undefined) {
                let poDate = moment(new Date(response[i].po_date));
                let year = parseInt(poDate.format("YYYY"));
                if (chartData[year] === undefined) {
                  chartData[year] = {
                    name: "Year [" + year + "]",
                    data: ["", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                  };

                  customerPeriod[year] = [];
                }
                //let series = year_series.indexOf(parseInt(poDate.format('YYYY')));
                let series = year;
                let period_mount = parseInt(poDate.format("M"));
                if (customerPeriod[series][period_mount] === undefined) {
                  customerPeriod[series][period_mount] = [
                    response[i].cust_code
                  ];
                } else if (
                  customerPeriod[series][period_mount].indexOf(
                    response[i].cust_code
                  ) === -1
                ) {
                  customerPeriod[series][period_mount].push(
                    response[i].cust_code
                  );
                }
              }
              sumOfSet = 0;
              sumInvAmount = 0;
              // promoCode = "";
              for (let j = 0; j < response[i].trn_order.length; j++) {
                sumOfSet += response[i].trn_order[j].amount
                  ? parseFloat(response[i].trn_order[j].amount)
                  : 0;
                sumInvAmount += response[i].trn_order[j].inv_total_amount
                  ? parseFloat(response[i].trn_order[j].inv_total_amount)
                  : 0;
                // promoCode = response[i].trn_order[j].h_name ?
                //     response[i].trn_order[j].h_name :
                //     "";
              }
              // sumAmount += sumOfSet

              // self.totalAmount += response[i].total_amount ? parseFloat(response[i].total_amount) : 0;
              // self.totalNetAmount += response[i].inv_total_amount ? parseFloat(response[i].inv_total_amount) : 0;
              self.totalAmount += sumOfSet ? parseFloat(sumOfSet) : 0;
              self.totalNetAmount += sumInvAmount
                ? parseFloat(sumInvAmount)
                : 0;

              arrList.push({
                no: i + 1,
                cust_code: response[i].cust_code,
                customer_name_th: response[i].customer_name_th,
                po_date: response[i].po_date,
                sm_code: response[i].sm_code,
                po_no: response[i].po_no,
                inv_no: response[i].inv_no,
                h_name: response[i].h_name,
                sum_by_set: sumOfSet,
                inv_total_amount: sumInvAmount
              });
            }

            self.tbListReport = arrList;
            /* set Graph Line */
            let ymax = 0;
            Object.keys(customerPeriod).forEach(series => {
              customerPeriod[series].forEach((period, index) => {
                if (period.length > ymax) {
                  ymax = period.length;
                }
                chartData[series].data[index] = period.length;
              });
            });

            this.optionsChart.legend.data = [];
            this.optionsChart.series = [];
            Object.keys(chartData).forEach((series, index) => {
              this.optionsChart.legend.data.push(series.name);
              this.optionsChart.series[index] = {
                data: chartData[series].data,
                name: chartData[series].name,
                type: "line",
                itemStyle: { color: this.colorChartSeries[index] },
                lineStyle: { color: this.colorChartSeries[index] }
              };
            });
            // delete this.optionsChart.yAxis.min;
            // delete this.optionsChart.yAxis.max;

            if (response.length > 1) {
              this.optionsChart.yAxis.max = null;
            } else {
              this.optionsChart.yAxis.min = 0;
              this.optionsChart.yAxis.max = 100;
            }

            /*this.optionsChart.legend.data = [chartData[0].name, chartData[1].name, chartData[2].name]
                        this.optionsChart.series[0].data = chartData[0].data;
                        this.optionsChart.series[1].data = chartData[1].data;
                        this.optionsChart.series[2].data = chartData[2].data;
                        this.optionsChart.series[0].name = chartData[0].name;
                        this.optionsChart.series[1].name = chartData[1].name;
                        this.optionsChart.series[2].name = chartData[2].name;*/
            // this.chartSummaryOrder = sumOrder;
            this.chartSummaryCustomer = customerAll.length;
            this.chartSummaryOrder = PoAll.length;
            this.totalVD = VDAll.length;
            // this.chartSummaryAmount = sumAmount.toLocaleString(undefined, {
            //     minimumFractionDigits: 2,
            //     maximumFractionDigits: 2
            // });
            this.chartSummaryNetAmount = sumNetAmount.toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            );
            this.chartNetAmountLine = netAmountAll;
            this.$refs.lineChart.refresh();
            this.loadData = false;
          })
          .catch();
      } else {
        this.optionsChart.yAxis.min = 0;
        this.optionsChart.yAxis.max = 100;
        this.loadData = false;
      }
    }
  }
};
</script>

<style lang="scss">
#vd-report-page {
  background-color: #fff;
  padding: 20px 20px;
  font-family: lato;
  height: 100vh;
  overflow-y: auto;
  font-weight: 400;

  .md-layout-item {
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #797979;
    }

    &.chart,
    &.list-data {
      padding: 20px;

      .sub-title {
        font-size: 16px;
        font-weight: bold;
        color: #797979;
      }
    }

    &.list-data {
      padding-bottom: 0px;
    }

    &.table-data {
      padding: 8px 15px 20px 15px;
    }

    .-detail {
      margin: 25px 20px 20px 20px;

      .circle-2017 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        margin: auto;
        background-color: #32bbda;
      }

      .circle-2018 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        margin: auto;
        background-color: #8fb93e;
      }

      .circle-2019 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        margin: auto;
        background-color: #e61a8b;
      }

      .-series {
        width: 90%;
      }
    }

    .filter-chips {
      margin-top: 5px;
      margin-bottom: 20px;
      margin-left: 10px;

      .tab-chip {
        padding-left: 10px;
        padding-right: 8px;
        border-radius: 35px;
        color: white;
        font-size: 12px;
        padding-top: 5px;
        padding-bottom: 5px;

        &.-primary {
          // background-color: #3F51B5;
          background-color: #3f7fb5;
          margin-right: 5px;
        }

        &.-delete {
          // background-color: #11258c;
          background-color: #1c64a0;
          padding-left: 4px;
          padding-right: 4px;
          padding-top: 2px;
          padding-bottom: 2px;
          margin-left: 3px;
          cursor: pointer;

          .material-icons {
            font-size: 11px;
          }
        }
      }
    }
  }

  .main-content {
    margin-top: 15px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);

    .md-gutter {
      margin: 15px 0 15px 0;

      .box-filter-search {
        margin: 10px;
        padding: 5px;
        width: 355px;
        height: 125px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
        display: block;
        overflow-y: scroll;

        // .md-chip {
        //     width: 98%;
        //     margin: 2px 3px;
        // }

        .tab-chip {
          padding-left: 10px;
          padding-right: 8px;
          border-radius: 35px;
          color: white;
          font-size: 12px;
          padding-top: 5px;
          padding-bottom: 5px;
          display: flex;
          background-color: #3f7fb5;
          margin: 2px;

          .-primary {
            margin-right: 5px;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }

          &.-delete {
            // background-color: #11258c;
            background-color: #1c64a0;
            padding-left: 4px;
            padding-right: 4px;
            padding-top: 2px;
            padding-bottom: 2px;
            margin-left: 3px;
            cursor: pointer;

            .material-icons {
              font-size: 11px;
            }
          }
        }

        &::-webkit-scrollbar {
          height: 7px;
          width: 5px;
        }
      }

      .md-layout-item {
        // background-color: pink;

        .right-filter-search {
          margin-top: 20px;
          display: flex;

          &.-first {
            margin-top: 25px;
          }

          .title-search {
            width: 15%;
          }

          .value-search {
            width: 85%;
          }

          .virtual-input {
            &.cust-code {
              input {
                width: 100% !important;
              }
            }

            input {
              width: 85%;
              padding-left: 8px;
              padding-right: 13.8px;
              height: 36px;
              border: 1px solid #ddd;
              border-radius: 5px;
              background: #fff;
            }

            ::placeholder {
              color: #bdbdbd;
              opacity: 1;
              font-family: kanit;
              font-size: 12px;
              font-weight: 100;
            }
          }

          .mkt-datepicker {
            width: 95%;

            input {
              font-size: 14px;
            }

            .md-field {
              padding-top: 0px;
              margin: 0px;
              min-height: 35px;

              // .md-input-action {
              //     top: 15px;
              // }
            }
          }

          .search-report {
            margin: 0px;
            width: 120px;
            height: 35px;
            // background-color: rgb(239, 239, 239);
            // color: #727272;
            color: #ffffff;
            background-color: #3f51b5;
            border-radius: 3px;
            box-shadow: unset;
          }

          .mktops-subheader-filter {
            height: 38px;

            .md-field.box > .md-input.md-select-value,
            .md-field.box > .md-menu.md-select {
              font-size: 14px;
              width: 115.72px;
              height: 36px;
            }

            .md-field.md-field.box {
              margin-top: unset;
              margin-bottom: unset;
              padding: unset;
            }

            .md-field:after,
            .md-field:before {
              left: unset;
            }

            .md-field.box .md-input.md-input.md-select-value,
            .md-field.box label {
              font-size: 14px;
              padding-left: 12px;
              padding-top: 3px;
              color: #727272;
            }

            .md-field.box .md-select {
              background-color: #efefef;
              border-radius: 3px;
            }
          }
        }
      }
    }
  }

  .chart-line {
    width: 100%;

    > div {
      width: unset !important;
    }
  }

  .box-detail-chart {
    margin-right: 25px;
    padding: 10px;
    font-weight: 500;

    > div {
      margin: 10px;
    }

    .-total {
      display: flex;
    }

    // .-title {
    //     width: 45%;
    // }
    .-value {
      // width: 55%;
      color: #2b93ff;
      text-align: right;
    }
  }

  #table-volume-pricing {
    .row-bg-gray:hover {
      border-radius: 4px;
      background: rgba(236, 236, 235, 1);
    }

    .md-checkbox {
      display: flex;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-left: 0px !important;
    }

    #divHeadList {
      width: 99.6%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 13px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divBodyList {
      width: 100%;
      height: calc(100vmin - 300px);
      display: block;
      overflow-y: scroll;

      > div {
        width: 100%;
        // height: 45px;
        display: -webkit-inline-box;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;
          // height: 36px;
          height: 30px;
          display: table;

          span {
            vertical-align: middle;
            display: table-cell;
          }

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.-font-kanit {
            font-size: 14px;
            font-family: kanit;
            font-weight: 300;
          }
        }
      }

      .circle-green {
        width: 36px;
        height: 36px;
        background-color: #52b6b0;
        border-radius: 50px;
        margin: auto;
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    #divTableFoot {
      width: 99.5%;
      display: -webkit-inline-box;
      font-weight: bold;
      margin-top: 10px;
      // margin-bottom: 10px;

      font-size: 12px;
      font-family: Roboto;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }
  }

  &::-webkit-scrollbar {
    height: 7px;
    width: 6px;
  }

  .multiselect {
    .z-index-top {
      z-index: 10;
    }

    margin: 5px 0px;

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;

      div {
        display: flex;
        width: 100%;

        .-delete {
          width: 5%;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;

      input {
        font-family: lato;
        font-weight: 300;
      }

      .multiselect__placeholder {
        margin: 0px;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper {
      font-size: 14px;
      z-index: 10;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }
}

.filter-dialog {
  // height: 57% !important;
  height: 370px !important;
  top: 22% !important;

  .-action {
    position: absolute;
  }
}
</style>
